import React from 'react';
import styles from './styles.module.scss';

import AddMoodWithReason from './AddMoodWithReason';

const GreetingMoodTracker = () => {
  return (
    <div className={styles.page}>
      <AddMoodWithReason />
    </div>
  );
};
GreetingMoodTracker.propTypes = {};

export default GreetingMoodTracker;
